export default "__VITE_ASSET__DnEb4M8D__"